var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#E5E7DF",
    strokeWidth: 0.843,
    cx: 16.8,
    cy: 16.8,
    r: 16.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.829 7a.68.68 0 0 1 .484.204l-.057-.052.046.04.011.012 5.486 5.582a.693.693 0 0 1 .201.493l-.007-.102v.007l.007.095v11.163C25 25.855 23.874 27 22.486 27H11.514C10.126 27 9 25.855 9 24.442V9.558C9 8.145 10.126 7 11.514 7h7.315zm-.687 1.395h-6.628c-.63 0-1.143.52-1.143 1.163v14.884c0 .642.512 1.163 1.143 1.163h10.972c.63 0 1.143-.52 1.143-1.163l-.001-10.466h-4.8a.69.69 0 0 1-.679-.602l-.006-.095-.001-4.884zm2.515 12.558c.379 0 .686.313.686.698a.694.694 0 0 1-.593.691l-.093.007h-7.314a.692.692 0 0 1-.686-.698c0-.353.258-.645.593-.691l.093-.007h7.314zm0-3.72c.379 0 .686.312.686.697a.694.694 0 0 1-.593.692l-.093.006h-7.314a.692.692 0 0 1-.686-.698c0-.353.258-.645.593-.691l.093-.006h7.314zm-5.486-3.721c.38 0 .686.312.686.697a.694.694 0 0 1-.593.692l-.093.006h-1.828a.692.692 0 0 1-.686-.698c0-.353.258-.645.593-.691l.093-.006h1.828zm4.343-4.13v3.2l3.144-.001-3.144-3.199z",
    fill: "#8CAEB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.8daab4901ec0f5af2a5f2a987dc5a159.svg";
export { ForwardRef as ReactComponent };